import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {ReportsService} from '../../reports.service';
import {appColors} from '../../../core/styles/colors';
import {EChartsOption, SeriesOption} from 'echarts';
import {DurationPipe} from '../../../core/pipes/duration.pipe';
import {chartDefaultOptions, chartExpandIcon} from '../../../core/styles/chart-defauls';
import {MatDialog} from '@angular/material/dialog';
import {MatChartByUserDialogComponent} from './mat-chart-by-user-dialog.component';
import {LegendOption, TitleOption} from 'echarts/types/dist/shared';
import { NgxEchartsDirective } from 'ngx-echarts';


@Component({
    selector: 'app-chart-by-user',
    templateUrl: './chart-by-user.component.html',
    standalone: true,
    imports: [NgxEchartsDirective]
})
export class ChartByUserComponent implements OnInit, OnDestroy, OnChanges {

  @Input() public data: any[] = [];
  @Input() showTimeSeries = false;
  @Input() showExpand = false;
  @Input() chartTitle = 'Total Calls By Agent';

  @ViewChild('expandBtn') expandBtn;

  colors = appColors;
  updateOptions: EChartsOption = {};
  initOptions = {};

  options: EChartsOption = {
    title: Object.assign({}, chartDefaultOptions.title, {
      text: 'Total Calls By Agent'
    }),
    legend: Object.assign({}, chartDefaultOptions.legend),
    grid: Object.assign({}, chartDefaultOptions.grid),
    toolbox: [{
      show: true,
      feature: {
        dataZoom: {
          yAxisIndex: 'none'
        },
        saveAsImage: {},
        myZoom: {
          show: this.showExpand,
          title: 'Expand',
          icon: chartExpandIcon,
          onclick: () => {
            console.log('on expand click');
            this.expandBtn.nativeElement.click();
          }
        }
      }
    }],
    dataZoom: [
      {
        type: 'inside',
        filterMode: 'filter',
        start: 0,
        end: 100,
      },
      {
        start: 0,
        end: 100,
      },
    ],
    xAxis: {
      type: 'category',
      boundaryGap: true
    },
    yAxis: [{
      type: 'value',
      scale: true,
      min: 0,
      axisLine: {
        show: true,
      },
      name: 'Total Count',
      nameGap: 30,
      nameRotate: 90,
      nameLocation: 'middle',
      axisLabel: {
        formatter: (value, index) => {
          if (this.showTimeSeries) {
            return this.durationPipe.transform(value);
          } else {
            return `${value}`;
          }
        }
      }
    }],
    series: [],
    tooltip: {
      show: true,
      trigger: 'axis',
      axisPointer: {
        label: {
          formatter: (params) => {
            const name = this.reportsService.getExtensionName(params.value as string);
            return name || params.value;
          }
        }
      },
      valueFormatter: (value: any) => {
        if (this.showTimeSeries) {
          return this.durationPipe.transform(value);
        } else {
          return value;
        }
      }
    },
  };

  private chart: any;

  constructor(public reportsService: ReportsService,
              public durationPipe: DurationPipe,
              public dialog: MatDialog) {
    const resizeObserver = new ResizeObserver(() => {
      this.resizeChart();
    });
    resizeObserver.observe(document.body);
  }

  ngOnInit() {
    console.log('my on init');
  }

  resizeChart() {
    if (this.chart) {
      this.chart.resize();
    }
  }

  onChartInit($event: any) {
    this.chart = $event;
    console.log('on chart init:', $event);
  }

  ngOnDestroy() {

  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('my on ngOnChanges');

    this.updateChart();
  }

  updateChart() {
    const groupedData = [...this.data];

    const series = [];

    if (!this.showTimeSeries) {
      (this.options.legend as LegendOption).show = true;

      this.options.yAxis[0].name = 'Total Count';
      this.options.yAxis[0].nameGap = 40;
      this.options.yAxis[0].nameRotate = 90;
      this.options.yAxis[0].nameLocation = 'middle';

      const answeredCalls: SeriesOption = {
        type: 'bar',
        name: 'Answered Calls',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.answeredCalls;
        }),
        color: this.colors.primaryGreen,
        stack: 'calls'
      };

      const outgoingCalls: SeriesOption = {
        type: 'bar',
        name: 'Outgoing Calls',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.outgoingCalls;
        }),
        color: this.colors.primaryBlue,
        stack: 'calls'
      };

      const missedCalls: SeriesOption = {
        type: 'bar',
        name: 'Missed Calls',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.canceled;
        }),
        color: this.colors.primaryRed,
        stack: 'calls'
      };

      const mailboxCalls: SeriesOption = {
        type: 'bar',
        name: 'Mailbox Calls',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.answeredByMailbox;
        }),
        color: this.colors.orange,
        stack: 'calls'
      };

      series.push(answeredCalls);
      series.push(outgoingCalls);
      series.push(missedCalls);
      series.push(mailboxCalls);
    } else {
      (this.options.legend as LegendOption).show = false;

      this.options.yAxis[0].name = 'Avg. Duration';
      this.options.yAxis[0].nameGap = 15;
      this.options.yAxis[0].nameRotate = 0;
      this.options.yAxis[0].nameLocation = 'end';

      const avgTalkCalls: SeriesOption = {
        type: 'bar',
        name: 'Avg. Talk Time',
        barMaxWidth: 80,
        data: groupedData.map(item => {
          return item.avgTalkDuration;
        }),
        color: this.colors.orange,
        stack: 'calls'
      };

      series.push(avgTalkCalls);
    }

    this.options.toolbox[0].feature.myZoom.show = this.showExpand;
    (this.options.title as TitleOption).text = this.chartTitle;


    this.updateOptions = {
      title: this.options.title,
      toolbox: this.options.toolbox,
      series: series,
      legend: this.options.legend,
      yAxis: this.options.yAxis,
      xAxis: {
        data: groupedData.map(item => {
          return item.extension;
        })
      },
    };
  }

  onExpandClick() {
    this.dialog.open(MatChartByUserDialogComponent, {
      width: '90%',
      height: '90%',
      data: {
        chartData: this.data,
        dialogTitle: this.chartTitle,
        showTimeSeries: this.showTimeSeries,
      }
    });
  }
}
